import {
  func, object, string, array, oneOfType, number,
} from 'prop-types';
import { isNil, clamp } from 'ramda';
import React, { useState } from 'react';

import { isObject } from '@ezugi/utils';

import Icon from '../Icon/Icon';
import {
  Container, Prev, Next, List, Item,
} from './style';

const ToggleSelect = ({
  defaultActive,
  onToggle,
  list,
  leftIcon,
  rightIcon,
  foreground,
  background,
  ...props
}) => {
  const [ active, setActive ] = useState(defaultActive);

  const toggle = (i) => {
    const newActive = clamp(0, list.length - 1)(active + i);
    setActive(newActive);
    onToggle(newActive);
  };

  const offset = `${-active * 100 }%`;

  return (
    <Container
      {...{
        ...props,
        style: {
          ...props.style,
          ...(!isNil(foreground) && { color: foreground, fill: foreground }),
          ...(!isNil(background) && { background }),
        },
      }}
    >
      <Prev tabIndex={-1} onClick={() => toggle(-1)} disabled={active === 0}>
        <Icon {...(isObject(leftIcon) ? leftIcon : { svg: leftIcon })} disabled={active === 0} />
      </Prev>
      <List>
        {list.map((item) => (
          <Item key={item} style={{ left: offset }}>
            {item}
          </Item>
        ))}
      </List>
      <Next tabIndex={-1} onClick={() => toggle(1)} disabled={active === list.length - 1}>
        <Icon {...(isObject(rightIcon) ? rightIcon : { svg: rightIcon })} disabled={active === list.length - 1} />
      </Next>
    </Container>
  );
};

ToggleSelect.propTypes = {
  list: array,
  style: object,
  defaultActive: number,
  leftIcon: oneOfType([ string, object ]),
  rightIcon: oneOfType([ string, object ]),
  background: string,
  foreground: string,
  onToggle: func,
};

ToggleSelect.defaultProps = {
  defaultActive: 0,
  onToggle: () => {},
  style: {},
};

export default ToggleSelect;
